import { Box } from '@material-ui/core';
import Collaborators from './Collaborators';
import { useEffect, useState } from "react";
import contractsProvider from "../../provider/contracts.provider";
import authProvider from "../../provider/auth.provider";

export const Footer = props => {
    const [show, setShow] = useState(true);
    const [logos, setLogos] = useState(null);
    const [isVisible, setIsVisible] = useState(false);


    useEffect(() => {
        let cancelled = false;
        let visibilityTimer;

        checkLocation()

        let locationInterval = setInterval(checkLocation, 1000)

        const fetchAuthAndData = async () => {
            if (!show || isLoginUrl(window.location.href) ||
                isScheduledActivityUrl(window.location.href) ||
                !localStorage.getItem('token') || logos !== null) {
                return;
            }

            try {
                const authResult = await authProvider.GetAuth();
                if (cancelled || !authResult?.contractLogoId) {
                    return;
                }

                const logosResult = await contractsProvider.getLogos('', {
                    contractId: authResult.contractLogoId,
                });
                if (cancelled) {
                    return;
                }
                setLogos(logosResult);

                visibilityTimer = setTimeout(() => {
                    setIsVisible(true);
                }, 2000);
            } catch (error) {
                if (!cancelled) {
                    setLogos(null);
                    setIsVisible(false);
                    console.error('No se pudieron cargar los logos del pie de página:', error);
                }
            }
        };

        fetchAuthAndData();

        return () => {
            cancelled = true;
            clearTimeout(visibilityTimer);
            clearInterval(locationInterval)
        }
        // eslint-disable-next-line
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [show])

    const checkLocation = () => {
        if (isLoginUrl(window.location.href) || isScheduledActivityUrl(window.location.href)) {
            setShow(false)  
        } else{
            setShow(true)  
        }
    }



    const isScheduledActivityUrl = (url) => {
        // Expresión regular para verificar si la URL contiene /scheduledActivities/{id}/show
        const scheduledActivityPattern = /\/#\/scheduledActivities\/\d+\/show/;
        return scheduledActivityPattern.test(url);
    }


    const isLoginUrl = (url) => {

        var responseLogin = url.includes('login');
        var responseChangePasswordPage = url.includes('changePasswordPage');
        var responseActivityCall = url.includes('activityCall');
        var responseAerialHabits = url.includes('AerialHabits');
        if(responseLogin || responseChangePasswordPage || responseActivityCall || responseAerialHabits){
            setLogos(null);
            setIsVisible(false);
        }

        var response = (responseLogin || responseChangePasswordPage);
        return response;
    }


    return (show && logos && (logos?.data?.panelDerecha !== null || logos?.data?.panelIzquierda !== null) ?
        <Box
        className={`footer ${isVisible ? 'visibleFooter' : 'hiddenFooter'}`}
        >
            <Collaborators logos={logos} />
        </Box> : null
    )
}
